import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'text-input',
  template: `<div *ngIf="position == 'vertical'" class="mb-4 form-group">
      <label
        [for]="controlName"
        class="block text-sm font-medium text-gray-700 flex items-center gap-1"
      >
        {{ label }}
        <span *ngIf="isRequired() && label !== '' && !removeRequired" class="text-red-500">*</span>

        <mat-icon
          *ngIf="tooltipText"
          svgIcon="mat_outline:info"
          [matTooltip]="tooltipText"
          [matTooltipPosition]="tooltipPosition"
          [matTooltipShowDelay]="showDelay"
          [matTooltipHideDelay]="hideDelay"
          class="text-grey-500 cursor-pointer icon-size-5"
        ></mat-icon>
      </label>

      <input
        *ngIf="readOnly; else fillable"
        readonly
        [type]="type"
        autocomplete="off"
        min="0"
        [placeholder]="placeholder"
        [formControl]="controlName"
        [id]="controlName"
        [name]="controlName"
        class="mt-1 h-8 w-full border border-gray-300 py-2 px-4 rounded-md form-control text-black"
        [ngClass]="[controlName.disabled ? disabledBG || 'bg-gray-100' : '']"
        [class.is-invalid]="controlName.invalid && controlName.touched"
      />
      <ng-template #fillable>
        <input
          [type]="type"
          min="0"
          autocomplete="off"
          [placeholder]="placeholder"
          [formControl]="controlName"
          [id]="controlName"
          [name]="controlName"
          class="mt-1 h-8 w-full border border-gray-300 py-2 px-4 rounded-md form-control text-black"
          [ngClass]="[controlName.disabled ? disabledBG || 'bg-gray-100' : '']"
          [class.is-invalid]="controlName.invalid && controlName.touched"
        />
      </ng-template>

      <form-validator [controlName]="controlName"></form-validator>
    </div>

    <div
      *ngIf="position == 'horizontal'"
      class="mb-4 flex flex-row justify-start items-center gap-3 w-full"
    >
      <label
        *ngIf="label !== ''"
        [class]="labelStyle"
        class="block text-sm font-medium text-gray-700 flex items-center gap-1"
      >
        {{ label }}
        <span *ngIf="isRequired() && label !== '' && !removeRequired" class="text-red-500">*</span>

        <!-- Tooltip Icon (only if tooltipText is provided) -->
        <mat-icon
          *ngIf="tooltipText"
          svgIcon="mat_outline:info"
          [matTooltip]="tooltipText"
          [matTooltipPosition]="tooltipPosition"
          [matTooltipShowDelay]="showDelay"
          [matTooltipHideDelay]="hideDelay"
          class="text-grey-500 cursor-pointer icon-size-5"
        ></mat-icon>
      </label>

      <div class="{{ inputBoxStyle }}">
        <input
          *ngIf="readOnly"
          readonly
          [type]="type"
          autocomplete="off"
          min="0"
          [placeholder]="placeholder"
          [formControl]="controlName"
          [id]="controlName"
          [name]="controlName"
          class="mt-1 h-8 border border-gray-300 rounded-md form-control"
          [ngClass]="[controlName.disabled ? disabledBG || 'bg-gray-100' : '']"
          [class.is-invalid]="controlName.invalid && controlName.touched"
        />

        <input
          *ngIf="!readOnly"
          [type]="type"
          autocomplete="off"
          min="0"
          [placeholder]="placeholder"
          [formControl]="controlName"
          [id]="controlName"
          [name]="controlName"
          class="mt-1 h-8 w-full border border-gray-300 py-2 px-4 rounded-md form-control"
          [ngClass]="[controlName.disabled ? disabledBG || 'bg-gray-100' : '']"
          [class.is-invalid]="controlName.invalid && controlName.touched"
        />
      </div>

      <form-validator [controlName]="controlName"></form-validator>
    </div> `,
})
export class TextInputComponent implements OnInit, OnChanges {
  @Input() label: string = '';
  @Input() readOnly: boolean = false;
  @Input() removeRequired: boolean = false;
  @Input() type: string = 'text';
  @Input() controlName: FormControl = new FormControl('');
  @Input() placeholder: string = '';
  @Input() position: string = 'vertical';
  @Input() inputBoxStyle: string = '';
  @Input() labelStyle: string = 'w-fit';
  @Input() disabled: boolean = false;
  @Input() disabledBG: string = 'bg-gray-100';

  @Input() tooltipText: string = ''; // text shown in tooltip
  @Input() tooltipPosition: 'above' | 'below' | 'left' | 'right' = 'below';
  @Input() showDelay: number = 200;
  @Input() hideDelay: number = 100;

  ngOnInit(): void {}
  ngOnChanges(): void {
    if (this.disabled) {
      this.controlName.disable();
    } else {
      this.controlName.enable();
    }
    this.controlName.updateValueAndValidity();
  }

  public isRequired(): boolean {
    // check form if they have a required validation
    return this.controlName.hasValidator(Validators.required);
  }
}
